import FormWidget from "../form-widget.js";

class FileUploadWidget extends FormWidget {
    public override process() {
        const fieldEl = this.element as HTMLInputElement;
        const accept: string = fieldEl.getAttribute('accept') ?? '';
        let previewContainerEl: HTMLElement|null = null;
        if(fieldEl.closest('.form-element')) {
            previewContainerEl = fieldEl.closest('.form-element')!.querySelector<HTMLElement>('.preview')!;
        }


        if(
            window.File && window.FileReader && window.Blob
            && previewContainerEl !== null
            && (
                fieldEl.classList.contains('image-upload')
                || accept.search(/application\/pdf|image/i) > -1
            )
        ) {

            const maxWidth = (fieldEl.dataset.maxWidth) ? parseInt(fieldEl.dataset.maxWidth) : 0;
            fieldEl.addEventListener('change', (ev: Event) => {
                if(fieldEl.files && fieldEl.files[0]) {
                    const file = fieldEl.files[0];
                    if(file.type.search('application/pdf') > -1 || file.type.search('image/') > -1) {
                        previewContainerEl.innerHTML = '';
                        const reader = new FileReader();
                        reader.addEventListener('load', (progressEvent: ProgressEvent<FileReader>) => {
                            if(file.type.search('application/pdf') > -1) {
                                const previewEl = document.createElement('embed');
                                previewEl.src = reader.result ? reader.result.toString() : '';
                                previewEl.setAttribute('type', 'application/pdf');
                                previewEl.style.width = '100%';
                                previewEl.style.height = '300px';
                                previewContainerEl.append(previewEl);
                            } else {
                                let previewEl = previewContainerEl.querySelector('img');
                                if(previewEl == null) {
                                    previewEl = document.createElement('img');
                                    previewContainerEl.append(previewEl);
                                }
                                previewEl.src = reader.result ? reader.result.toString() : '';
                                if(maxWidth > 0) {
                                    const image = new Image();
                                    image.addEventListener('load', (ev: Event) => {
                                        const canvas = document.createElement('canvas');
                                        let width = image.width;
                                        let height = image.height;
                                        if(width > height) {
                                            if(width > maxWidth) {
                                                height *= maxWidth / width;
                                                width = maxWidth;
                                            }
                                        } else {
                                            if(height > maxWidth) {
                                                width *= maxWidth / height;
                                                height = maxWidth;
                                            }
                                        }
                                        canvas.width = width;
                                        canvas.height = height;
                                        canvas.getContext('2d')?.drawImage(image, 0, 0, width, height);
                                        const dataUrl = canvas.toDataURL(file.type);
                                        previewEl.setAttribute('src', dataUrl)
                                        canvas.toBlob((blob) => {
                                            if(blob) {
                                                const newFile = new File([blob], file.name, {
                                                    type: file.type
                                                });
                                                const dataTransfer = new DataTransfer();
                                                dataTransfer.items.add(newFile);
                                                fieldEl.files = dataTransfer.files;
                                            }
                                        }, file.type);
                                    });

                                    image.src = reader.result ? reader.result.toString() : '';
                                }
                            }
                        });

                        reader.readAsDataURL(fieldEl.files[0]);
                    }
                }
            });
        }


    }

}

export default FileUploadWidget;
